import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

export default function AccessoNegato() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div style={styles.box}>
        <IconaDivieto />
        <h2 style={styles.titolo}>Accesso non consentito</h2>
        <p style={styles.testo}>
          Non hai il permesso per aprire questa sezione.
          <br />
          Se ti serve, chiedi all'amministratore dello studio di abilitarla.
        </p>
        <button onClick={() => navigate('/')} style={styles.btn}>Torna alla home</button>
      </div>
    </Layout>
  );
}

// Icona di divieto disegnata in SVG, uguale su tutti i computer (nessun font o emoji)
function IconaDivieto() {
  return (
    <svg width="72" height="72" viewBox="0 0 72 72" role="img" aria-label="Divieto" style={{ display: 'block', margin: '0 auto' }}>
      <circle cx="36" cy="36" r="34" fill="#F7F7EA" />
      <circle cx="36" cy="36" r="24" fill="none" stroke="#272727" strokeWidth="6" />
      <line x1="19" y1="53" x2="53" y2="19" stroke="#272727" strokeWidth="6" strokeLinecap="round" />
      <circle cx="36" cy="36" r="34" fill="none" stroke="#D3D678" strokeWidth="3" />
    </svg>
  );
}

const styles = {
  box: { maxWidth: '580px', margin: '4rem auto', textAlign: 'center', background: 'white', padding: '2.5rem 2rem', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  titolo: { margin: '1rem 0 0.5rem', color: '#232323' },
  testo: { color: '#666', fontSize: '0.95rem', lineHeight: 1.5 },
  btn: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', marginTop: '1rem' },
};
